import { Component, OnInit } from '@angular/core';
import { Settings } from 'src/app/app.settings.model';
import { AppSettings } from 'src/app/app.settings';
import { FindTimeResultItem } from 'src/app/core/models/find-time-result-item-model';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { FindTimeService } from 'src/app/core/services/find-time.service';
import { VisitItem } from 'src/app/core/models/visit-item';
import { AppData } from 'src/app/app.data';


@Component({
  selector: 'app-find-time-group-result',
  templateUrl: './find-time-group-result.component.html',
  styleUrls: ['./find-time-group-result.component.scss']
})
export class FindTimeGroupResultComponent implements OnInit {
  error:string;
  settings: Settings;
  freeTimeGroupList: FindTimeResultItem[];  

  constructor(private appSettings: AppSettings,
              private findtimeService: FindTimeService, 
              private appData: AppData,
              private location: Location,
              private router: Router) {

    this.settings = appSettings.settings;
    this.freeTimeGroupList = appData.findTimeGroupResult;    
  }

  ngOnInit() {
  }

  onSelect(item: FindTimeResultItem){
    this.appData.selectedFindTimeResultItemGroup = item;
    this.router.navigate(['/find-time-result']);
  }

  back(){
    this.location.back();
  }

  onAddToStandby(){
    this.router.navigate(['/standby']);
  }
}
